<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Log In</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Log In</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="login-area pt-100">
  <div class="container">
      <h2>Login Your Account</h2>

      <!-- <div class="login-wrap">
          <div class="row">
              <div class="col-sm-6 col-lg-6">
                  <div class="jobseeker-item">
                      <div class="jobseeker-icon">
                          <i class="flaticon-job-search"></i>
                      </div>

                      <div class="jobseeker-inner">
                          <span>Candidate</span>
                          <h3>Login as a Candidate</h3>
                      </div>

                      <a routerLink="/login">Get Started<i class="icofont-arrow-right"></i></a>
                  </div>
              </div>

              <div class="col-sm-6 col-lg-6">
                  <div class="jobseeker-item">
                      <div class="jobseeker-icon">
                          <i class="flaticon-recruitment"></i>
                      </div>

                      <div class="jobseeker-inner">
                          <span>Employer</span>
                          <h3>Login as a Employer</h3>
                      </div>

                      <a routerLink="/login">Get Started<i class="icofont-arrow-right"></i></a>
                  </div>
              </div>
          </div>
      </div> -->

     <div class="login-wrap">

        <form [formGroup]="lform" (ngSubmit)="login()">

            <div class="row">

              <div class="form-group">
                <input type="text" class="form-control"  formControlName="username"
                [ngClass]="{'is-invalid': displayMessage.username }" placeholder="username">
              </div>

              <div class="form-group">
                  <input type="password" class="form-control"  formControlName="password"
                  [ngClass]="{'is-invalid': displayMessage.password }" placeholder="password">
              </div>

            </div>

            <div class="login-sign-in">
              <!-- <a routerLink="/">Forgot Password?</a> -->

              <ul>
                  <li>Don’t Have Account ?</li>
                  <li><a routerLink="/sign-up">Sign Up Here</a></li>
              </ul>

              <div class="text-center">
                  <button type="submit" class="btn login-btn"
                  [title]="lform.valid"
                  [disabled]="!lform.valid"
                  >
                    Log In
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  </button>
              </div>

            </div>

        </form>

     </div>



      <!-- <div class="login-social">
          <a href="#"><i class="icofont-facebook"></i> Login With Facebook</a>
          <a class="login-google" href="#"><i class="icofont-google-plus"></i> Login With Google</a>
      </div> -->
  </div>
</div>
